// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['hy_AM']  = { // eslint-disable-line import/no-commonjs
  name: 'hy_AM',
  day: {
    abbrev: ['կրկ', 'երկ', 'երք', 'չրք', 'հնգ', 'ուրբ', 'շբթ'],
    full: [
      'կիրակի',
      'երկուշաբթի',
      'երեքշաբթի',
      'չորեքշաբթի',
      'հինգշաբթի',
      'ուրբաթ',
      'շաբաթ'
    ]
  },
  month: {
    abbrev: [
      'Հնվ',
      'Փտր',
      'Մրտ',
      'Ապր',
      'Մյս',
      'Հնս',
      'Հլս',
      'Օգս',
      'Սպտ',
      'Հկտ',
      'Նմբ',
      'Դկտ'
    ],
    full: [
      'հունվար',
      'փետրվար',
      'մարտ',
      'ապրիլ',
      'մայիս',
      'հունիս',
      'հուլիս',
      'օգոստոս',
      'սեպտեմբեր',
      'հոկտեմբեր',
      'նոյեմբեր',
      'դեկտեմբեր'
    ]
  },
  meridiem: ['առավոտվա', 'ցերեկվա'],
  date: '%d.%m.%Y',
  time24: '%T',
  dateTime: '%a, %d %b %Y թ., %R %Z',
  time12: '',
  full: '%a %b %e %H:%M:%S %Z %Y'
}
